import { render, staticRenderFns } from "./TimeExtenDetail.vue?vue&type=template&id=1846287a"
import script from "./TimeExtenDetail.vue?vue&type=script&lang=ts"
export * from "./TimeExtenDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports